// This must be in scope of a reference provider
import {CSSProperties, useContext, useId} from "react";
import {Board, QuestionInputConfig} from "../../javaTypes";
import {ReferenceContext} from "../ReferenceProvider";
import {Form} from "react-bootstrap";
import {t} from "ttag";
import {Program, Rule} from "first-common/javaTypes";
import Select from "react-select";
import {getTagRequirementLevel} from "./TopicEditor";

export function getRuleSort(program: Program) {
    const secOrder = program === Program.FRC ? "QGRITCE" : "IEAGRTLC";
    return (a?: Rule | string, b?: Rule | string) => {
        if (!a && !b) return 0;
        if (!a) return 1;
        if (!b) return -1;
        // use the index of the leading character * 10000 (could be 1000 but add a buffer just in case something weird happens)
        const toNum = (r: Rule | string) => secOrder.indexOf((typeof r === 'string' ? r : r.id).charAt(0)) * 10000 + parseInt((typeof r === 'string' ? r : r.id).substring(1));
        return toNum(a) - toNum(b);
    }
}

export default function RuleEditor({config, board, rule, setRule, style}: {
    config: QuestionInputConfig,
    board: Board,
    rule: string,
    setRule: (topic: string) => void,
    style?: CSSProperties
}) {
    const references = useContext(ReferenceContext);
    const id = useId();
    const rules = references?.rules ? Object.values(references.rules).sort(getRuleSort(board.season.program)) : [];
    return <Form.Group controlId={id} style={Object.assign({}, style ?? {}, {marginTop: '1ch'})}>
        <Form.Label style={{position: 'relative', top: '.75ch'}}>{t`Most-Relevant Rule`} {getTagRequirementLevel(config)}</Form.Label>
        <Select value={rules.find(x => x.id === rule)} onChange={e => setRule(e ? e.id : "")}
                     options={rules} getOptionValue={r => r.id} isClearable={true} escapeClearsValue={true}
                     getOptionLabel={r => r.id + " - " + r.headline}
                     styles={{option: (b, s) => ({...b, fontSize: '.9rem', padding: "4px 8px"})}}
        />
    </Form.Group>
}